import { Badge, Button, Group, Table, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { displayPartnerDomain } from "@/features/partners/normalize-partner-domain";
import type { CorporatePartner } from "@/features/partners/types";
import { ActiveBadge } from "@/shared/ui/active-badge";

export function PartnersTable({
	rows,
	page,
	hasNextPage,
	onPageChange,
	onEdit,
}: {
	rows: CorporatePartner[];
	page: number;
	hasNextPage: boolean;
	onPageChange: (page: number | ((value: number) => number)) => void;
	onEdit: (row: CorporatePartner) => void;
}) {
	const { t } = useTranslation();
	return (
		<>
			<Table.ScrollContainer type="native" minWidth={640}>
				<Table verticalSpacing="sm">
					<Table.Thead>
						<Table.Tr>
							<Table.Th>{t("common.name")}</Table.Th>
							<Table.Th>{t("partners.domains")}</Table.Th>
							<Table.Th miw={120}>{t("common.status")}</Table.Th>
							<Table.Th />
						</Table.Tr>
					</Table.Thead>
					<Table.Tbody>
						{rows.map((row) => (
							<Table.Tr key={row.id}>
								<Table.Td>{row.name}</Table.Td>
								<Table.Td>
									<Group gap={4}>
										{row.domains.map((domain) => (
											<Badge key={domain.id} variant="light" tt="none">
												{displayPartnerDomain(domain.domain)}
											</Badge>
										))}
									</Group>
								</Table.Td>
								<Table.Td miw={120} style={{ whiteSpace: "nowrap" }}>
									<ActiveBadge active={row.isActive} />
								</Table.Td>
								<Table.Td>
									<Button size="xs" variant="light" onClick={() => onEdit(row)}>
										{t("common.edit")}
									</Button>
								</Table.Td>
							</Table.Tr>
						))}
					</Table.Tbody>
				</Table>
			</Table.ScrollContainer>
			<Group justify="space-between" mt="md">
				<Text size="sm" c="dimmed">
					{t("common.page")} {page}
				</Text>
				<Group>
					<Button
						variant="default"
						disabled={page <= 1}
						onClick={() => onPageChange((value) => value - 1)}
					>
						{t("common.previous")}
					</Button>
					<Button
						variant="default"
						disabled={!hasNextPage}
						onClick={() => onPageChange((value) => value + 1)}
					>
						{t("common.next")}
					</Button>
				</Group>
			</Group>
		</>
	);
}
